module.exports = __webpack_public_path__ + "static/img/copar.f71951a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/thumbnails/projects/copar.png
// module id = Xk8m
// module chunks = 0